import * as yup from 'yup';

const email = {
  base: yup.string().email('errorMessages.email')
};
email.required = email.base.required('errorMessages.required');
email.optional = email.base;

export default email;
